import { Headline } from 'components/Headline';
import { Warning } from 'components/Warning';

import { useMyLists } from './MyLists.hooks';
import * as S from './MyLists.styles';
import { NewListModal } from './components/NewListModal';

export function MyLists(): React.ReactElement {
  const { selections, columns, isModalVisible, isModalVisibleSet, t } = useMyLists();

  return (
    <S.Container>
      {selections && selections.length > 0 ? (
        <Warning>{t('selection.removedProductNote')}</Warning>
      ) : null}

      {selections && selections.length > 0 ? (
        <S.ListTable motive="tertiary" columns={columns} data={selections} />
      ) : (
        <Headline scale="xl2">{t('selection.noListsYet')}</Headline>
      )}

      <S.AddButton
        motive="grayPrimary"
        fontWeight="extraBold"
        onClick={() => isModalVisibleSet(!isModalVisible)}
        scale="xl"
      >
        {t('selection.newList')}
      </S.AddButton>

      {isModalVisible ? (
        <NewListModal onClose={() => isModalVisibleSet(!isModalVisible)} />
      ) : null}
    </S.Container>
  );
}
